import { usePdfViewerQuery } from 'generated/graphql';
import React from 'react';

export interface IData {
  id: string;
  url: string;
}

export function useQuery(apiFileId: string) {
  const tuple = usePdfViewerQuery({
    variables: {
      id: apiFileId
    },
    skip: apiFileId === ''
  });

  return React.useMemo(
    () => {
      const data: IData = {
        id: tuple.data?.apiFile?.id ?? '',
        url: tuple.data?.apiFile?.url ?? ''
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
